import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { commonActions } from "../store/common.slice";
import SpinnerLoader from "../components/SpinnerLoader";
import Termsofserevice from "./termsofserevice";
import Privacypolicy from "./privacypolicy";

// Single shareable page for both Terms of Service and Privacy Policy, reusing the
// same checkedinpage/cardOrange shell used elsewhere in the app. The legalCard
// modifier swaps the card to a white background and scrolls the text body inside
// the card instead of scrolling the whole page.
// Which section renders is determined by the route path:
//   /terms/condition -> Terms of Service only
//   /privacy/policy  -> Privacy Policy only
function Legal() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [cmsContent, setCmsContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const showTerms = location.pathname.startsWith("/terms");
  const showPrivacy = location.pathname.startsWith("/privacy");
  const pageTitle = showTerms ? "Terms of Service" : "Privacy Policy";

  useEffect(() => {
    const fetchCmsContent = async () => {
      const result = await dispatch(commonActions.getCmsContents());
      setCmsContent(result?.payload?.result);
      setIsLoading(false);
    };
    fetchCmsContent();
  }, [dispatch]);

  return (
    <section className="checkedinpage">
      <h3 className="text-center" id="checkedInpage">
        {pageTitle}
      </h3>
      {isLoading ? (
        <div className="text-center">
          <SpinnerLoader />
        </div>
      ) : (
        <div className="card-section">
          {showTerms && (
            <div className="cardOrange legalCard">
              <div className="content">
                <div className="moreContent">
                  <Termsofserevice data={cmsContent?.term_of_service} />
                </div>
              </div>
            </div>
          )}
          {showPrivacy && (
            <div className="cardOrange legalCard">
              <div className="content">
                <div className="moreContent">
                  <Privacypolicy data={cmsContent?.privacy_policy} />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

export default Legal;
